import { useTranslation } from 'react-i18next';
import { Button } from '@/components/Button';
import type { AdCard as AdCardData } from '@/api/types';

interface Props {
  ad: AdCardData;
  onSubscribe: () => void;
}

export function AdCard({ ad, onSubscribe }: Props) {
  const { t } = useTranslation();
  return (
    <div className="flex-1 flex flex-col p-6 justify-between">
      {/* Бейдж */}
      <div className="self-start text-[10px] tracking-widest font-semibold text-text-muted bg-text/5 px-2 py-1 rounded-pill">
        {t('feed.ad_label')}
      </div>

      <div className="flex-1 flex flex-col items-center justify-center text-center gap-4">
        <div className="w-12 h-12 rounded-lg bg-surface-strong grid place-items-center text-base font-medium">
          {ad.brand?.name?.[0] ?? '·'}
        </div>
        <div className="text-sm text-text-muted">{ad.brand?.name}</div>
        <h3 className="font-content text-2xl text-text">{ad.headline}</h3>
        <p className="text-text-muted max-w-xs">{ad.description}</p>
      </div>

      <div className="flex flex-col gap-3">
        <Button block size="lg" onClick={() => window.open(ad.cta.url, '_blank')}>
          {ad.cta.label}
        </Button>
        <button
          onClick={onSubscribe}
          className="text-xs text-text-muted underline underline-offset-2 self-center"
        >
          {t('feed.remove_ads_cta', { price: ad.remove_ads_offer.price_ton })}
        </button>
      </div>
    </div>
  );
}
